export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/3317921172ca4bd192ea.js");
}
